<div
    [ngClass]="{ '-on': isModalOpened$ | async, '-off': (isModalOpened$ | async) === false }"
    class="modal__overlay"
    (click)="onCancelModal()"
></div>
<div
    [ngClass]="{ '-on': isModalOpened$ | async, '-off': (isModalOpened$ | async) === false, large: modalType === modalTypeEnum.LARGE }"
    class="modal"
>
    <div class="modal__card" [ngClass]="modalType">
        <div class="modal__top">
            <h3>{{ title | translate }}</h3>
            <button
                *ngIf="this.modalType !== modalTypeEnum.NEXT_YEAR_TRANSITION"
                (click)="onCancelModal()"
                class="modal__close-btn"
            ></button>
        </div>
        <div class="modal__content" [id]="modalParentIdEnum.FULL_CONTENT">
            <div class="modal__text">
                <ng-container *ngIf="hasBody">
                    <div *ngIf="text">
                        <p [innerHTML]="text | translate"></p>
                    </div>
                </ng-container>
                <div [id]="modalParentIdEnum.BODY_CONTENT"></div>
                <div *ngIf="validateButtonLabel || cancelButtonLabel || buttons" class="modal__footer">
                    <div class="row-btn-action buttons-container">
                        <app-generic-button
                            *ngIf="validateButtonLabel"
                            [classes]="'btn btn--primary'"
                            [inputText]="validateButtonLabel"
                            (buttonClick)="onValidateClicked()"
                        >
                        </app-generic-button>
                        <ng-container *ngFor="let button of buttons || []">
                            <app-generic-button
                                *ngIf="button.placement === 'middle'"
                                [classes]="button.klass"
                                [inputText]="button.label"
                                (buttonClick)="button.fct()"
                            >
                            </app-generic-button>
                        </ng-container>
                        <app-generic-button
                            *ngIf="cancelButtonLabel"
                            [classes]="'btn btn--secondary'"
                            [inputText]="cancelButtonLabel"
                            (buttonClick)="onCancelModal()"
                        >
                        </app-generic-button>
                        <ng-container *ngFor="let button of buttons || []">
                            <app-generic-button
                                *ngIf="!button.placement || button.placement === 'end'"
                                [classes]="button.klass"
                                [inputText]="button.label"
                                (buttonClick)="button.fct()"
                            >
                            </app-generic-button>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
